export const ROUNDING_PRECISION = 7;

export const MAX_SCORE = 3;
export const MIN_SCORE = 0;

export const FIRST_ASSESSMENT_INDEX = 0;

export const scaleRating = (value) => parseFloat((value / MAX_SCORE).toFixed(ROUNDING_PRECISION));

export const isAValidAssessment = (assessment, isAssessmentPassed) => (isAssessmentPassed !== assessment?.pass);
